import './header';
import './font-size-adjust';
import './side-nav';
import './dropdown';
import './slideshow';
import './newsletter-signup';
import './ckeditor-accordion-overrides';
import PensionCalc from './pension-calculator';
import objectFitImages from 'object-fit-images';

(function(Drupal, $, once) {
  'use strict';
  // This is the entry point JS file, use this mainly for imports.

  Drupal.behaviors.entry = {
    attach: function(context, settings) {
      // Object Fit Images polyfill init:
      objectFitImages();

      // Init Pension Calculator:
      $(once('pension-calc', '#penCalcForm', context)).each(function(i, element) {
        if (!element.pensionCalc) {
          element.pensionCalc = new PensionCalc(element);
        }
      });
    }
  };

  // AddEvents widget on event listing:
  window.addeventasync = function(){
    addeventatc.settings({
      appleical  : {show:true, text:"Apple Calendar"},
      google     : {show:true, text:"Google <em>(online)</em>"},
      outlook    : {show:true, text:"Outlook"},
      outlookcom : {show:true, text:"Outlook.com <em>(online)</em>"},
      yahoo      : {show:true, text:"Yahoo <em>(online)</em>"}
    });

    setTimeout(function(){addeventatc.refresh();}, 200);
  };

})(Drupal, jQuery, once);
